//
//
//
//

import { AppMain } from "./components";
import { mapState } from 'vuex';
export default {
  name: 'LayoutChildren',
  components: {
    AppMain: AppMain
  }
};